import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TheNavbar = _resolveComponent("TheNavbar")
  const _component_router_view = _resolveComponent("router-view")
  const _component_TheFooter = _resolveComponent("TheFooter")
  const _component_Analytics = _resolveComponent("Analytics")
  const _component_el_config_provider = _resolveComponent("el-config-provider")

  return (_openBlock(), _createBlock(_component_el_config_provider, { locale: $setup.zhCn }, {
    default: _withCtx(() => [
      _createVNode(_component_Analytics, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            ($setup.showHeader)
              ? (_openBlock(), _createBlock(_component_TheNavbar, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(_component_router_view),
            _createVNode(_component_TheFooter)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["locale"]))
}